/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Downpayment/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Downpayment({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/Steps/Content/PaymentPlans/Content/Content/PaymentPlan/Content/Content/Insurances/Insurance/Subscription/EditAction/Content/Edit/Content/Downpayment"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
let insuranceInsuredInsuranceSubscriptionInsurancePlanTxCategoryCoveragesOrthoCoveragesValueData = fromData.useDataFormat({ viewPath,
context: 'insurance',
path: 'insured.insurance_subscription.insurance_plan.tx_category_coverages.ortho_coverages',
format: fromHelpers.getValue,
})
let dtColorsBlack = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.black'
        })
  return (<React.Fragment
>
<div
  data-testid="Downpayment.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-1-ZM8Ln2': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Downpayment"
 color={dtColorsNeutral600}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 color={dtColorsBlack}
 data="insurance.insured.insurance_subscription.insurance_plan.tx_category_coverages.ortho_coverages"
 format="helpers.js getValue"
 text={insuranceInsuredInsuranceSubscriptionInsurancePlanTxCategoryCoveragesOrthoCoveragesValueData}
/>
</div>
{children}
</React.Fragment>)
}